module.exports = __webpack_public_path__ + "img/member_discovery.b1a0c6f5.png";